import React from "react";

import { Box, Card, Typography, useTheme } from "@mui/material";
import {
    Payments as PaymentsIcon,
    Money as MoneyIcon,
    TrendingUpSharp as TrendingUpSharpIcon,
    AccountBalanceWallet as AccountBalanceWalletIcon
} from "@mui/icons-material";

import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import LockIcon from '@mui/icons-material/Lock';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

interface BudgetCardProps {
    label: string;
    value: string;
    icon: string;
    color: "red" | "amber" | "green" | 'info';
    removeMoney?: boolean;
};

export const BudgetCard: React.FC<BudgetCardProps> = ({ label, value, icon, color, removeMoney }) => {
    return (
        <Card variant="outlined" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderColor: "divider", gap: 2, px: 2, py: 1, width: '100%' }}>
            <Box display={'flex'} flexDirection={'column'}>
                <Typography variant="body2" color="text.secondary">{label}</Typography>
                <Typography variant="h5" color="text.primary">
                    {
                        removeMoney ? `${value}` : `£ ${value}`
                    }
                </Typography>
            </Box>
            {

                icon === 'Lock' ? <LockIcon fontSize="large" sx={{ color: '#546E7A' }} /> :
                    icon === 'Compare' ? <CompareArrowsIcon fontSize="large" sx={{ color: 'warning.main' }} /> :
                        icon === 'Assignment' ? <AssignmentTurnedInIcon fontSize="large" sx={{ color: 'info.light' }} /> :
                            icon === 'Pending' ? <PendingActionsIcon fontSize="large" sx={{ color: '#FFA000' }} /> :
                                icon === 'Receipt' ? <ReceiptLongIcon fontSize="large" sx={{ color: '#5E35B1' }} /> :
                                    icon === 'Balance' ? <AccountBalanceWalletIcon fontSize="large" sx={{ color: color === 'red' ? 'error.main' : color === 'amber' ? 'warning.main' : color === 'green' ? 'success.main' : 'info.main' }} /> :
                                        icon === 'Cost' ? <PaymentsIcon fontSize="large" sx={{ color: color === 'red' ? 'error.main' : color === 'amber' ? 'warning.main' : color === 'green' ? 'success.main' : 'info.main' }} /> :
                                            icon === 'Money' ? <MoneyIcon fontSize="large" sx={{ color: color === 'red' ? 'error.main' : color === 'amber' ? 'warning.main' : color === 'green' ? 'success.main' : 'info.main' }} /> :
                                                icon === 'Trending' ? <TrendingUpSharpIcon fontSize="large" sx={{ color: color === 'red' ? 'error.main' : color === 'amber' ? 'warning.main' : color === 'green' ? 'success.main' : 'info.main' }} /> : null
            }
        </Card>
    );
};